'use strict'

import axios from 'axios'
import qs from 'qs'

axios.interceptors.request.use(config => {
  return config
}, err => {
  alert('请求超时!')
  return Promise.resolve(err)
})
		// let base = 'http://ywsh.pkurg.com:27031/'         // 北大资源的
     // let base = 'http://corp.lesoft.com.cn:8091/'    // 测试的
     let base = 'http://lswx.lesoft.com.cn:8091/'       // 正式的，端口都是8091
     //let noticeBaseUrl = 'http://192.168.1.40:8888'
     let noticeBaseUrl = 'http://lswx.lesoft.com.cn:8888'     // 以前写的都是8888
export const postRequest = (url, params,Func, isNotice) => {
  axios({
    method: 'post',
    url: isNotice=== 'n'?`${noticeBaseUrl}${url}` :  `${base}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
	    'authorization':sessionStorage.getItem('userName'),
      'token':sessionStorage.getItem('token')
    }
  }).then(data=>{
    if (data.data.code === 200) {
      Func(data.data.data)
    }else if(data.data.code === 406){
      alert(data.data.message)
    }else if(data.data.code === 401){
      alert('认证失败')
    }else if(data.data.code === 400 || data.data.code === 505 || data.data.code === 404|| data.data.code === 500){
      alert('网络异常')
    }
  })
}

export const postRequestN9 = (url, params,Func,isNotice) => {
  axios({
    method: 'post',
    url: isNotice=== 'n'?`${noticeBaseUrl}${url}` :  `${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // }
  }).then(data=>{
    if (data.data.StateCode === 0) {
      Func(data.data.Result)
    }else if(data.data.StateCode === 4){
      alert(data.data.ErrorMsg)
    }else if(data.data.StateCode === 3){
      alert(data.data.ErrorMsg)
    }else{
      alert('网络异常')
    }
    sessionStorage.setItem('btn-isDisabled',false)
  })
}

export const uploadFileRequestN9 = (url, params) => {
  return axios({
    method: 'post',
    url: `${url}`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}


export const uploadFileRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data',
	    'authorization':sessionStorage.getItem('userName'),
      'token':sessionStorage.getItem('token')
    }
  })
}
export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
	    'authorization':sessionStorage.getItem('userName'),
      'token':sessionStorage.getItem('token')
    }
  })
}
export const deleteRequest = (url) => {
  return axios({
    method: 'delete',
    url: `${base}${url}`
  })
}
export const getRequest = (url) => {
  return axios({
    method: 'get',
    url: `${url}`
  })
}



// WEBPACK FOOTER //
// ./src/api/http.js